import { render, staticRenderFns } from "./WuguWarehouseStaff.vue?vue&type=template&id=a6d17c0e&"
import script from "./WuguWarehouseStaff.vue?vue&type=script&lang=js&"
export * from "./WuguWarehouseStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports